<div class="row divider">
    <div class="col col-main-heading mb-1 d-lg-block d-none">
        <h3 class="mt-3 mb-2">{{ title() }} ({{ count() }})</h3>
    </div>
</div>
@if (count() === 0) {
    <div class="row not-found">
        <div class="col">
            <p>{{ emptyText() }}</p>
        </div>
    </div>
} @else {
    @for (card of cards(); track card.id) {
        <div class="row divider ps-1 ps-lg-0">
            <pace-notification-card
                class="cursor-pointer col position-relative"
                [class]="borderClass(card)"
                [card]="card"
                (cardSelect)="cardSelect.emit(card)"
            ></pace-notification-card>
        </div>
    }
}
